import React from 'react'

class PerformanceDates extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: this.props.dates || []
		}
	}

	handleAddNewItem(){
		// Render a new form.
		const items = this.state.items

		// Generate a new id.
		const id = items.reduce( (id, item) => {
			if(item.id >= id){
				id = parseInt(item.id, 10) + 1
			}
			return id
		}, 0)

		// Add the new item to the list.
		items.push({
			id: id,
			date: '', // 'Friday, April 10'
			time: ''
		})

		// Save it to state.
		this.setState({ items })
	}

	handleItemRemove(id){
		// Filter the list by the item selected to remove.
		// eslint-disable-next-line
		const items = this.state.items.filter( item => item.id != id )

		// Save the updated array to state.
		this.setState({ 
			items: items,
		})
	}

	handleItemUpdate(form){
		// Generate a new list updating the selected item.
		var items = this.state.items.map( item => {
			// eslint-disable-next-line
			if(item.id == form.getAttribute('data-id')){
				return {...item,
					date: encodeURIComponent(form.querySelector('.date').value),
					time: encodeURIComponent(form.querySelector('.time').value)
				}
			} else {
				return item
			}
		})

		this.setState({ 
			items: items
		})
	}

	render() {
		return (
			<section className="performance_dates">
				<h3>Performance Dates</h3>
				{this.state.items.map( (item, i) => { 
					return (
						<div key={i} data-id={item.id} className="date_container" onChange={ (e) => {this.handleItemUpdate(e.target.closest('div'))} }>
								<input type="date" defaultValue={item.date} className="date" />
								@ 
								<input type="time" defaultValue={item.time} className="time" />
								<button className="delete" onClick={ (e) => {this.handleItemRemove(item.id)} }>Delete</button>
						</div>
					)
				})}
				<button className="add button" onClick={this.handleAddNewItem.bind(this)}>Add Performance</button>
			</section>
		)
	}
}

export default PerformanceDates


// WEBPACK FOOTER //
// ./src/components/performance_dates.js